import { Box, Typography, Avatar, Card, CardContent, Stack, Link } from '@mui/material';
import { WorkOutlineOutlined as WorkOutlineIcon } from '@mui/icons-material';
import { formatDateRange } from '../../lib/format';
import Badge from '../../components/Badge';

function DeliverableChip({ item }) {
  const sx = {
    fontSize: 12,
    px: 1,
    py: 0.25,
    borderRadius: 1,
    bgcolor: 'action.hover',
  };
  if (!item.contentUrl) {
    return (
      <Box component="span" sx={{ ...sx, color: 'text.secondary' }}>
        {item.platform}
      </Box>
    );
  }
  return (
    <Link
      href={item.contentUrl}
      target="_blank"
      rel="noreferrer"
      underline="none"
      sx={{ ...sx, color: 'text.primary', '&:hover': { bgcolor: 'action.selected' } }}
    >
      {item.platform} ↗
    </Link>
  );
}

function PublicCollabCard({ collab }) {
  const dateRange = formatDateRange(collab.startDate, collab.endDate);

  return (
    <Card variant="outlined" sx={{ borderRadius: 3, boxShadow: '0 1px 3px rgba(20, 10, 50, 0.06)', borderLeft: 4, borderLeftColor: 'primary.main' }}>
      <CardContent sx={{ p: { xs: 2, sm: 2.5 } }}>
        <Stack direction="row" spacing={1.75}>
          {collab.brandLogoUrl ? (
            <Avatar src={collab.brandLogoUrl} variant="rounded" sx={{ width: 44, height: 44, flexShrink: 0 }} />
          ) : (
            <Box
              sx={{
                width: 44,
                height: 44,
                flexShrink: 0,
                borderRadius: 2,
                bgcolor: 'action.hover',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <WorkOutlineIcon sx={{ color: 'text.disabled', fontSize: 20 }} />
            </Box>
          )}
          <Box sx={{ flexGrow: 1, minWidth: 0 }}>
            <Stack direction="row" spacing={1.5} sx={{ alignItems: 'baseline', justifyContent: 'space-between' }}>
              <Typography noWrap sx={{ fontWeight: 700 }}>
                {collab.campaign}
              </Typography>
              {dateRange && (
                <Typography variant="caption" color="text.secondary" sx={{ flexShrink: 0, whiteSpace: 'nowrap' }}>
                  {dateRange}
                </Typography>
              )}
            </Stack>
            <Stack direction="row" spacing={1} sx={{ alignItems: 'center', flexWrap: 'wrap', mt: 0.25 }}>
              <Typography variant="body2" color="text.secondary">
                {collab.brand}
              </Typography>
              {collab.type && <Badge>{collab.type}</Badge>}
            </Stack>
            {collab.description && (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                {collab.description}
              </Typography>
            )}
            {collab.deliverables.length > 0 && (
              <Stack direction="row" spacing={0.75} useFlexGap sx={{ mt: 1, flexWrap: 'wrap' }}>
                {collab.deliverables.map((item) => (
                  <DeliverableChip key={item.id} item={item} />
                ))}
              </Stack>
            )}
            {collab.testimonial && (
              <Typography variant="body2" sx={{ mt: 1, fontStyle: 'italic', color: 'text.secondary' }}>
                “{collab.testimonial}”
              </Typography>
            )}
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
}

export default PublicCollabCard;
